export const BACKUP_DELETE_RESET = 'BACKUP_DELETE_RESET'
export const BACKUP_DELETE_SET_ERROR = 'BACKUP_DELETE_SET_ERROR'
export const BACKUP_DELETE_SET_DELETED = 'BACKUP_DELETE_SET_DELETED'
export const BACKUP_DELETE_TOGGLE_LOADING = 'BACKUP_DELETE_TOGGLE_LOADING'
